window.theme.component('whatsapp-group-link', el => {
	const trigger = el.querySelector('.js-whatsapp-group-trigger');
	const msg = el.querySelector('.js-whatsapp-group-msg');

	if (!trigger) return;

	function isAndroid() {
		return /Android/i.test(navigator.userAgent);
	}

	// Android's intent:// scheme tells the OS to open the named app directly,
	// bypassing whatever universal-link handling a host app's in-app browser
	// (TikTok, Instagram) does, which otherwise can wrongly prompt to
	// (re)install WhatsApp even when it's already on the device.
	function buildIntentUrl(rawUrl) {
		try {
			const url = new URL(rawUrl);
			return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=https;package=com.whatsapp;end`;
		} catch (error) {
			return rawUrl;
		}
	}

	function showMessage(text, isError) {
		if (!msg) return;
		msg.classList.remove('hidden');
		msg.classList.toggle('is-error', !!isError);
		msg.textContent = text;
	}

	async function copyLink(link) {
		try {
			await navigator.clipboard.writeText(link);
			return true;
		} catch (error) {
			return false;
		}
	}

	trigger.addEventListener('click', async () => {
		const link = trigger.dataset.link || '';
		if (!link) return;

		// Always copy the link, on every platform: the intent:// redirect
		// below can silently fail or get blocked by the host in-app browser
		// (some show a "link not supported" error instead of opening
		// WhatsApp), so the visitor needs a way to recover regardless of
		// whether that redirect actually worked.
		const copied = await copyLink(link);
		showMessage(
			copied
				? 'Link copiado! Se o WhatsApp não abrir sozinho, cole esse link numa página do navegador pra entrar no grupo.'
				: link,
			!copied
		);

		if (isAndroid()) {
			window.location.href = buildIntentUrl(link);
		}
	});
});
